import React, { useState, useEffect } from "react";
import { Switch, Checkbox, Row, Col, Collapse, Radio, Form, Input } from "antd";
// style
import styles from "./form.module.css";

const { Panel } = Collapse;

const ULPForm = ({ disabledState, isAdmin, getFieldValue, setFieldsValue }) => {
  const [solutionAccess, setSolutionAccess] = useState(
    getFieldValue("ulp_solution_access"),
  );
  const [payRollUser, setPayRollUser] = useState(
    getFieldValue("ulp_payroll_user"),
  );

  useEffect(() => {
    setSolutionAccess(getFieldValue("ulp_solution_access"));
  }, [getFieldValue("ulp_solution_access")]);

  useEffect(() => {
    if (getFieldValue("ulp_payroll_user") === true) {
      setPayRollUser(false);
    } else setPayRollUser(getFieldValue("ulp_payroll_user"));
  }, [getFieldValue("ulp_payroll_user")]);

  const solutionAccessOnChange = (value) => {
    setSolutionAccess((prevState) => !prevState);
    setFieldsValue({ ulp_solution_access: value });
  };

  const payRollUserHandler = (e) => {
    setPayRollUser(e.target.value);
    setFieldsValue({ ulp_payroll_user: e.target.value });
  };
  return (
    <Collapse defaultActiveKey={["ulp_1"]} expandIconPosition="end">
      <Panel header="ULP" key="ulp_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="ulp_solution_access"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={disabledState}
                    onChange={solutionAccessOnChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          {/* Comment for SMR 276 task requirements */}
          {isAdmin && (
            <>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Add New Report</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={2} xl={3} lg={4} sm={6}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="ulp_add_new_report"
                          valuePropName="checked"
                        >
                          <Checkbox
                            disabled={
                              disabledState ||
                              !getFieldValue("ulp_solution_access")
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Payroll User</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={24} xl={24} lg={24} sm={24}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="ulp_payroll_user"
                          valuePropName="checked"
                        >
                          <Radio.Group
                            value={getFieldValue("ulp_payroll_user")}
                            disabled={
                              disabledState ||
                              !getFieldValue("ulp_solution_access")
                            }
                            onChange={payRollUserHandler}
                          >
                            <Radio value="false">False</Radio>
                            <Radio value="engineering">Engineering</Radio>
                            <Radio value="housekeeping">Housekeeping</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Onboarding Team Access</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={2} xl={3} lg={4} sm={6}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="ulp_onboarding_team_access"
                          valuePropName="checked"
                        >
                          <Checkbox
                            disabled={
                              disabledState ||
                              !getFieldValue("ulp_solution_access")
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>File Mapping Update</label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      <Col xxl={2} xl={3} lg={4} sm={6}>
                        <Form.Item
                          style={{
                            borderBottom: "none",
                          }}
                          name="ulp_file_mapping_update"
                          valuePropName="checked"
                        >
                          <Checkbox
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </div>
      </Panel>
    </Collapse>
  );
};

export default ULPForm;
